import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BankAccountDataService } from '../../services/bank-account-data.service';
import { DynamicItem } from 'src/app/models/dynamicItem';
import { PopupNewIdentifierComponent } from '../popups/popup-new-identifier/popup-new-identifier.component';
import { CommonService } from '../../services/common/common.service';

@Component({
  selector: 'app-account-discover',
  templateUrl: './account-discover.component.html',
  styleUrls: ['./account-discover.component.scss']
})


export class AccountDiscoverComponent implements OnInit {

  fip: any;
  bankLogos;
  identifier: string;
  breadcrumb: { "label": string; "link": any[]; }[] = [];
  selectIdentifierIndex = -1;
  popupData: any;
  showPopupFlag: boolean = false;
  indentifierType: any;
  identifierValue: any;
  identifiersInfo: any = [];
  temp;
  showError = false;

  constructor(
    private route: Router,
    private bankService: BankAccountDataService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.fip = this.bankService.getSelectedFip();
    if (!this.fip) {
      this.route.navigate(['/account-list']);
    }
    this.getBankLogos();
    this.setBreadcrumb();
    this.getIdentifiers();
  }

  /**
   * 
   * @param form -form {on submitting Identifier}
   */
  submitIdentifier() {
    if(this.selectIdentifierIndex == -1) {
      this.setErrorState(true);
      return;
    } else {
      this.setErrorState(false);
    }
    this.postAccountDiscover();
  }

  setErrorState(boolean) {
    this.showError = boolean
  }

  /**
   * Discovery call by passing fipID that we got from bank List components
   */
  postAccountDiscover() {
    var dataObject = [];
    this.identifiersInfo.forEach(element => {
      dataObject.push({
        "type":element.type.toUpperCase(),
        "value":element.value
      })
    });

    let data = {
      "fipID": this.fip.FIPID,
      "fips":[{
      "data":dataObject
      }]
    }
    let option = {
      type: 'post',
      url: 'accountdiscover',
      includeUserSession: true,
      isDeveloper: true,
      data: data
    }
    let that = this;
    this.bankService.discoverAccounts(option, function () {
      that.route.navigate(['/link-account']);
    }, this.fip);
  }

  /**
   * function to get bank Logos
   */
  getBankLogos() {
    this.bankService.getBanksLogos().subscribe((res) => {
      if (res != undefined) {
        this.bankLogos = res;
      }
    });
  }

  currentlySelected(index) {
    this.selectIdentifierIndex = index;
    this.setErrorState(false);
  }

  showpopup() {
    let popuptext: any = {
      heading: "NEW IDENTIFIER",
      body: this.fip.FIPID,
      successCallback: this.addNewIdentifier.bind(this),
      cancelCallback: this.closePopup.bind(this)
    }
    this.popupData = new DynamicItem(PopupNewIdentifierComponent, popuptext);
    this.showPopupFlag = true;
  }


  getIdentifiers() {
    this.commonService.getUserIdentifiers().subscribe((res) => {
      this.identifiersInfo = res?res:[];
      if(this.identifiersInfo.length>0){
        this.selectIdentifierIndex=0;
      }
    });
  }

  addNewIdentifier(identifier) {
    this.showPopupFlag = false;
    identifier.fipId = this.fip.FIPID;

    if(identifier.check) {
      this.commonService.postIdentifiersInfo(identifier).subscribe((res) => {
        this.getIdentifiers();
      });
    } else {
      this.identifiersInfo=[];
      this.identifiersInfo.push(identifier);
      this.selectIdentifierIndex = this.identifiersInfo.length - 1;
    }
  }

  closePopup() {
    this.showPopupFlag = false;
  }

  setBreadcrumb() {
    this.breadcrumb = [
      { "label": "Link your " + this.fip.FIPName, "link": ["/account-list"] },
    ];
  }
}
